export const CART_API_TIMEOUT = 15000
export const SCROLL_RESTORATION_KEY = 'jh-scroll-restoration'
export const UPSELL_GROUP_PROPERTY = '_upsell_group'
export const UPSELL_ONLY_TAG = 'upsell-only'
export const UPSELL_PARENT_PROPERTY = '_upsell_parent'
